import type { ApiResponse, RequestError } from './types';

const parseJson = async <T>(response: Response): Promise<ApiResponse<T>> => {
  try {
    return await response.json() as ApiResponse<T>;
  } catch {
    return { success: response.ok, statusCode: response.status, message: response.statusText } as ApiResponse<T>;
  }
};

/**
 * Parses the ApiResponse<T> envelope and throws a status-bearing RequestError for any
 * non-ok response or an ok response whose envelope reports `success: false`.
 */
export const parseOrThrow = async <T>(response: Response): Promise<ApiResponse<T>> => {
  const body = await parseJson<T>(response);
  if (!response.ok || body.success === false) {
    const error: RequestError = {
      status: response.status || body.statusCode,
      message: body.message ?? `Request failed: ${response.status || body.statusCode}`,
    };
    throw error;
  }
  return body;
};
